import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import { Tabs, Typography, Spin, Row, Col, Input, message, Button } from 'antd'
import { Queries, Mutations } from '../../../../graphql'
import Container from '../../../../components/user/Container'
import FormInputAddress from '../../../../components/user/FormInputAddress'
import TabsBlockProFile from '../../../../components/user/TabsBlockProFile'
import { datasetsProfileDetail, tabProfile } from '../../../../config/datasetsProfile'
import { checkType } from '../../../../utils/checkType'
import { pushAge } from '../../../../utils/formatdate'
import moment from 'moment'

const { TabPane } = Tabs
const { Text, Title } = Typography

const newsDataProfile = '';

class Address extends Component {
	state = {
		detailProfile : [],
		dataNewProfile : {},
		loaddingDataNews : false,
		swiptBox:'detail',
		// swiptBox:'xxxx',
		dataFormInputAddress:[],
		dorpDownProvinc:[],
		dorpDownAmphur:[],
		dorpDownDistrict:[],
		idProvince: null,
		idAmphur:null,
		idDistrict :null,
		modalShowMessage: false
	}

	filterProvince = async (value) =>{
		const { client, location } = this.props
		const { data, errors } = await client.query({
			query: Queries.dropdownListProvince,
		})

		let dataId = null

		data.dropdownListProvince.filter(data => data.name.includes(value)).map(dataFilter => {
			dataId = dataFilter.id
		})

		await this.setState({
			idProvince:dataId,
			dorpDownProvinc:data.dropdownListProvince
		})

		return dataId
	}

	filterAmphur = async (value) =>{
		const { idProvince } = this.state
		const { client, location } = this.props
		const { data, errors } = await client.query({
			query: Queries.dropdownListAmphur,
			variables: {
				id : idProvince
			}
		})

		let dataId = null
		data.dropdownListAmphur.filter(data => data.name.includes(value)).map(dataFilter => {
			dataId = dataFilter.id
		})

		await this.setState({
			idAmphur:dataId,
			dorpDownAmphur:data.dropdownListAmphur
		})

		return dataId
	}

	filterDistrict = async (value) =>{
		const { idAmphur } = this.state
		const { client, location } = this.props
		
		const { data, errors } = await client.query({
			query: Queries.dropdownListDistrict,
			variables: {
				id : idAmphur
			}
		})

		console.log('data',data)

		// let dataId = null
		// data.dropdownListDistrict.filter(data => data.name.includes(value)).map(dataFilter => {
		// 	dataId = dataFilter.id
		// })

		// await this.setState({
		// 	idDistrict:dataId,
		// 	dorpDownDistrict:data.dropdownListAmphur
		// })

		// return dataId
	}

	fetchProfile = async () =>{
		try {
			const { client, location } = this.props

			const { data, errors } = await client.query({
				query: Queries.detchProfileListDetail,
			})

			let dataFormInputAddress = [];
			if(data.fetchAddress){
				// console.log(data.fetchAddress)
				Object.keys(data.fetchAddress).map((keys)=>{
					dataFormInputAddress[keys] = data.fetchAddress[keys] ? data.fetchAddress[keys] : !data.fetchAddress[keys] ? '' : data.fetchEmployeeProfile.address[keys]
				})
			}else{
				Object.keys(data.fetchEmployeeProfile.address).map((keys)=>{
					dataFormInputAddress[keys] = data.fetchEmployeeProfile.address[keys] ? data.fetchEmployeeProfile.address[keys] : ' '
				})

				// dataFormInputAddress['province'] = await this.filterProvince(dataFormInputAddress['province'])
				// dataFormInputAddress['amphur'] = await this.filterAmphur(dataFormInputAddress['amphur'])
				// dataFormInputAddress['district'] = await this.filterDistrict(dataFormInputAddress['district'])
			}

			console.log('data',data)

			this.setState({
				detailProfile: data,
				dataFormInputAddress
			})
		} catch (error) {
			// const errorMessage = error.graphQLErrors[0].message
			// message.error("Token is expired.")
		}
	}

    inputForm = (title, values, keyInput) =>{
		return(
			keyInput == 'input' && 
				<Col xs={24} sm={12} className="mb-3">
					<div className="">
						<Text>
							{ title }
						</Text><br></br>
						<Input 
							value={ values ? values : 'ไม่พบข้อมูล' } 
							className={ values ? values : 'font-italic' } 
							disabled={true}
						/>
					</div>
				</Col>
			||
			<Col xs={24} sm={12} className="mb-3">
					<div className="">
						<Text>
							{ title }
						</Text><br></br>
						<Input.TextArea 
							value={ values ? values : 'ไม่พบข้อมูล' } 
							className={ values ? values : 'font-italic' } 
							autoSize="2"
							disabled={true}
						/>
					</div>
				</Col>
		)
	}

    tabsOne = () =>{
		const { detailProfile } = this.state
		return (
			<TabPane tab={'ที่อยู่ที่สามารถติดต่อได้'} key="1" className="mb-0">
				<Row gutter={16}>
					<Col xs={24} md={24} className="mb-2">
						<strong className="color-red">
							ที่อยู่ที่สามารถติดต่อได้
						</strong>
					</Col>
                    <>
                        {/* { this.inputForm('ชื่อที่อยู่', detailProfile.fetchEmployeeProfile ? detailProfile.fetchEmployeeProfile.address.addressName ? detailProfile.fetchEmployeeProfile.address.addressName : '' : '', 'input') } */}
                        { this.inputForm(
								'เลขที่', 
								detailProfile.fetchEmployeeProfile ? detailProfile.fetchEmployeeProfile.address.addressNo ? detailProfile.fetchEmployeeProfile.address.addressNo : '' : '',
								'input'
							)
						}
                        { this.inputForm(
								'หมู่ที่', 
                                detailProfile.fetchEmployeeProfile ? detailProfile.fetchEmployeeProfile.address.groupNo ? detailProfile.fetchEmployeeProfile.address.groupNo : '' : ''
                                , 'input' 
							) 
						}
                        { this.inputForm('อาคาร', detailProfile.fetchEmployeeProfile ? detailProfile.fetchEmployeeProfile.address.building ? detailProfile.fetchEmployeeProfile.address.building : '' : '', 'input' ) }
                        { this.inputForm('เลขที่ห้อง', detailProfile.fetchEmployeeProfile ? detailProfile.fetchEmployeeProfile.address.roomNo ? detailProfile.fetchEmployeeProfile.address.roomNo : '' : '', 'input') }
                        { this.inputForm('ชั้นที่', detailProfile.fetchEmployeeProfile ? detailProfile.fetchEmployeeProfile.address.floorNo ? detailProfile.fetchEmployeeProfile.address.floorNo : '' : '', 'input') }
                        { this.inputForm(
								'หมู่บ้าน', 
								detailProfile.fetchEmployeeProfile ? detailProfile.fetchEmployeeProfile.address.vilage ? detailProfile.fetchEmployeeProfile.address.vilage : '' : '',
								'input'
							) 
						}
                        { this.inputForm(
								'ตรอกซอย/ซอย', 
								detailProfile.fetchEmployeeProfile ? detailProfile.fetchEmployeeProfile.address.lane ? detailProfile.fetchEmployeeProfile.address.lane : '' : '',
								'input'
							) 
						}
                        { this.inputForm(
								'ถนน', 
								detailProfile.fetchEmployeeProfile ? detailProfile.fetchEmployeeProfile.address.street ? detailProfile.fetchEmployeeProfile.address.street : '' : '',
								'input'
							) 
						}
                       
                        
                        { this.inputForm(
								'จังหวัด', 
								detailProfile.fetchEmployeeProfile ? detailProfile.fetchEmployeeProfile.address.province ? detailProfile.fetchEmployeeProfile.address.province : '' : '',
								'input'
							) 
						}
						{ this.inputForm(
								'อำเภอ/เขต', 
								detailProfile.fetchEmployeeProfile ? detailProfile.fetchEmployeeProfile.address.amphur ? detailProfile.fetchEmployeeProfile.address.amphur : '' : '',
								'input'
							) 
						}
						 { this.inputForm(
								'ตำบล/แขวง', 
								detailProfile.fetchEmployeeProfile ? detailProfile.fetchEmployeeProfile.address.district ? detailProfile.fetchEmployeeProfile.address.district : '' : '',
								'input'
							) 
						}
                        { this.inputForm(
                                'รหัสไปรษณีย์', 
                                detailProfile.fetchEmployeeProfile ? detailProfile.fetchEmployeeProfile.address.postalCode ? detailProfile.fetchEmployeeProfile.address.postalCode : '' : '',
                                'input'
                            ) 
						}
                        {/* { this.inputForm(
                                'ประเทศ', 
                                detailProfile.fetchEmployeeProfile ? detailProfile.fetchEmployeeProfile.address.country ? detailProfile.fetchEmployeeProfile.address.country : '' : '',
                                'input'
                            ) 
						} */}

                        {/* { this.inputForm(
                                'โทรศัพท์ (มือถือ)', 
                                detailProfile.fetchEmployeeProfile ? detailProfile.fetchEmployeeProfile.address.phone1 ? detailProfile.fetchEmployeeProfile.address.phone1 : '' : '',
                                'input'
                            ) 
						} */}
						
                        {/* { this.inputForm(
                                'อีเมล', 
                                detailProfile.fetchEmployeeProfile ? detailProfile.fetchEmployeeProfile.address.email1 ? detailProfile.fetchEmployeeProfile.address.email1 : '' : '',
                                'input'
                            ) 
						} */}
                    </>
					{/* <Col xs={24} md={24} className="mb-2">
						<strong>หมายเหตุ</strong>
						<p style={{ color:"#a2a2a2" }}>
							หากพบว่าข้อมูลของท่านไม่ถูกต้อง สามารถติดต่อขอปรับปรุงข้อมูลกับหน่วยงาน HR ต้นสังกัดของท่าน ดังนี้<br></br>
							- สำนักงานบริหารทรัพยากรบุคคล (สบค.) ติดต่อได้ที่งานฐานข้อมูลบุคลากร 0 2256 4058<br></br>
							- โรงพยาบาลจุฬาลงกรณ์ ติดต่อได้ที่ Call Center ของฝ่ายบริหารทรัพยากรบุคคล  0 2256 4000 ต่อ 4747<br></br>
							- โรงพยาบาลสมเด็จพระบรมราชเทวี ณ ศรีราชา ติดต่อได้ที่งานฐานข้อมูลบุคลากร  0 38320 200 ต่อ 3419<br></br>
						</p>
					</Col> */}
				</Row>
			</TabPane>
		)
	}

	swiptBoxShow = async (data) =>{
		window.scrollTo(0, 0);
		this.setState({
			swiptBox: data
		})

		await this.fetchProfile()
	}

	handleSubmitDarf = async (values) => {
		const { dataFormInputAddress, detailProfile }  = this.state
		console.log('values',values)
		console.log('sss',dataFormInputAddress['addressId'])
		try {
			const { client } = this.props
			let checkStatus = false
			if(detailProfile.fetchAddress){
				const { data, errors } = await client.mutate({
					mutation: Mutations.updateAddress,
					variables: {
						...values,
						addressId: dataFormInputAddress['addressId'],
						isDelete: 1
					}
				})
				console.log('data',data)
				checkStatus = data.updateAddress.status
			}else{
				const { data, errors } = await client.mutate({
					mutation: Mutations.createAddress,
					variables: {
						...values,
						isDelete: 1
					}
				})

				checkStatus = data.createAddress.status
			}

			if(checkStatus){
				window.scrollTo(0, 0);
				message.success('บันทึกฉบับร่างเรียบร้อย');
				await this.fetchProfile()

				await this.setState({
					swiptBox: 'detail',
				})

				// await this.setState({
				// 	modalShowMessage: true
				// })
				
				// setTimeout( async() => {
				// 	await this.setState({
				// 		swiptBox: 'detail',
				// 		modalShowMessage: false
				// 	})
				// }, 3000);
			}
		} catch (error) {
			console.log(error)
		}
	}

	async componentDidMount(){
		await this.fetchProfile()
    }

	render() {
		const { history, location, match, staticContext } = this.props
		const { swiptBox, detailProfile, dataFormInputAddress, dorpDownDistrict, dorpDownProvinc, dorpDownAmphur, modalShowMessage} = this.state
		return (
			<Container match={match}>
				<div className="card-container" id="page-profile">
					{
						swiptBox == 'detail' &&
						<>
							<div className="px-5 py-1 card-bg-green">
								{
									detailProfile.length !== 0 &&
									<Tabs type="card" style={{borderBottom:"6px solid #d7222a"}} className="my-4">
										{ this.tabsOne() }
									</Tabs>
								}
							</div>
							<div className="mt-5">
								<Row>
									<Col align="center">
										<Button className="btn-link-page-custom-edit" onClick={ () => this.swiptBoxShow('form') }>
											แก้ไขข้อมูล 
										</Button>
									</Col>
								</Row>
							</div>
						</>
						||
						<>
							<div className="px-5 py-1 card-bg-green">
								<Tabs type="card" style={{borderBottom:"6px solid #d7222a"}} className="my-4">
									<TabPane tab={'ที่อยู่ที่สามารถติดต่อได้'} key="1" className="mb-0">
										<FormInputAddress 
											dataAddressForm={dataFormInputAddress}
											handleSubmitDarf={this.handleSubmitDarf}
											modalShowMessage={modalShowMessage}
										/>
									</TabPane>
								</Tabs>
							</div>
							<div className="mt-5">
								<Row>
									<Col align="center">
										<Button className="btn-link-page-custom-edit" onClick={ () => this.swiptBoxShow('detail') }>
											กลับไปหน้าดูข้อมูล 
										</Button>
									</Col>
								</Row>
							</div>
						</>
					}
					
				</div>
			</Container>
		)
	}
}

Address.propTypes = {
	//
}

export default withApollo(Address)
